import SelectableSet from './selectable-set';
import Prediction from '../views/prediction';

export default SelectableSet.extend( {
	modelView: Prediction,
} );
